import { render, staticRenderFns } from "./about_cooperation.vue?vue&type=template&id=28fcc49c&scoped=true&"
import script from "./about_cooperation.vue?vue&type=script&lang=js&"
export * from "./about_cooperation.vue?vue&type=script&lang=js&"
import style0 from "./about_cooperation.vue?vue&type=style&index=0&id=28fcc49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fcc49c",
  null
  
)

export default component.exports